function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { SUPPORT_TYPES_LIST } from '../util';
export function ColorLayer(props) {
  var type = props.type;
  var isCustom = SUPPORT_TYPES_LIST.indexOf(type) < 0;
  var cls = usePrefixCls('color-layer', _defineProperty({}, type, !isCustom));
  return React.createElement("div", {
    className: cls,
    style: {
      background: isCustom ? type : undefined
    }
  });
}